module.exports = __webpack_public_path__ + "img/astana-club.2d5618ba.png";